<template>
<div id="kt_header" class="header header-fixed" :style="topBarColor">
	<div class="container-fluid  d-flex align-items-stretch justify-content-between">
		<div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
			<div id="kt_header_menu" class="header-menu header-menu-mobile header-menu-layout-default">
				<ul class="menu-nav">
					<li class="menu-item  font-size-h5">
						{{ brand_name }}
					</li>
				</ul>
			</div>
		</div>
		<div class="topbar">
			<template v-if="store.state.brand?.plan?.description?.toLowerCase().includes('gold') ||
    						store.state.brand?.plan?.description?.toLowerCase().includes('platinum')">
				<ChatIcon 
					class="topbar-item mr-4" 
					style="cursor: pointer;" 
					svg-color="secondary"
					svg-title="OrderCircle Chats" 
					:unread-count="totalUnreadCount"
					@click="toggleDrawer"
				/>
				<Drawer :is-drawer-active="isDrawerActive" :drawer-title="`OrderCircle Chats`"
					@hideDrawerToggle="hideDrawer">
					<template #drawerTop>
						<div class="drawer-availability-section">
							<div class="availability-profile">
								<div class="availability-avatar">
									{{ currentUserInitials }}
									<span class="profile-status-dot" :class="isAvailable ? 'active' : 'offline'"></span>
								</div>
								<div class="availability-identity">
									<strong>{{ currentUserName }}</strong>
									<span><i :class="isAvailable ? 'active' : 'offline'"></i>{{ isAvailable ? 'Active' : 'Offline' }}</span>
								</div>
							</div>

							<button type="button" class="availability-action" :class="{ 'set-active': !isAvailable }"
								@click="toggleAvailability">
								<i :class="isAvailable ? 'far fa-clock' : 'fas fa-check-circle'" aria-hidden="true"></i>
								{{ isAvailable ? 'Set yourself offline' : 'Set yourself active' }}
							</button>
						</div>
					</template>
					<template #drawerContent>
						<div class="card-body p-0">
							<chat />
						</div>
					</template>
					<template #drawerOverlay>
						<ChatBox style="margin-right: 500px;" v-for="(user, index) in openChats" :key="index" :index="index" :user="user"
							:position="index" />
					</template>
				</Drawer>
			</template>
			<Notifications></Notifications>
			<div class="dropdown">
				<div class="dropdown" id="kt_quick_search_toggle">
					<div class="topbar-item" data-toggle="dropdown" data-offset="10px,0px">
							<div class="btn btn-icon btn-clean btn-lg btn-dropdown mr-1">
								<span class="svg-icon svg-icon-xl svg-icon-primary" id="search_icon">
									<!--begin::Svg Icon | path:assets/media/svg/icons/General/Search.svg-->
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
										<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
											<rect x="0" y="0" width="24" height="24" />
											<path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
											<path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fill-rule="nonzero" />
										</g>
									</svg>
									<!--end::Svg Icon-->
								</span>
							</div>
						</div>
					<div class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
						<div class="quick-search quick-search-dropdown" id="">
							<form class="quick-search-form" onsubmit="return false">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="svg-icon svg-icon-lg">
												<!--begin::Svg Icon | path:assets/media/svg/icons/General/Search.svg-->
												<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
													<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<rect x="0" y="0" width="24" height="24" />
														<path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
														<path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fill-rule="nonzero" />
													</g>
												</svg>
												<!--end::Svg Icon-->
											</span>
										</span>
									</div>
									<input id="search_field" type="text" @keyup.enter="searchFilter" v-model="searchQuery" 
										   class="form-control" placeholder="Search Orders and Customers..." />
									<div class="input-group-append">
										<span class="input-group-text">
											<i class="quick-search-close ki ki-close icon-sm text-muted"></i>
										</span>
									</div>
								</div>
							</form>
							<div class="quick-search-wrapper scroll" data-scroll="true" data-height="325"
								data-mobile-height="200"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="topbar-item">
				<AccountDetails></AccountDetails>
			</div>
		</div>
	</div>
</div>
</template>
<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import AccountDetails from '@/js/ordercircle/brands/layouts/accountdetails.vue';
import Notifications from '@/js/ordercircle/brands/layouts/notifications.vue';
import ChatIcon from '@/js/svgs/chat-icon.vue';
import Drawer from '@/js/theme/components/drawer.vue';
import chat from '@/js/theme/components/chats/index.vue'
import ChatBox from '@/js/theme/components/chats/box.vue'
import { getUnreadMessagesCount, setUserAvailability, setupUserPresence } from '@/js/utils/firebase';

const store = useStore();
const router = useRouter();
const brand_name = computed(() => store.getters.brand['brand_name']);
const searchQuery = ref('');
const openChats = computed(() => store.getters['openChats']);
const totalUnreadCount = ref(0);
const isDrawerActive = ref(false);
const availability = ref('active');
let stopPresenceListener = () => {};

const isAvailable = computed(() => availability.value === 'active');
const currentUserName = computed(() => (
	store.getters.user.user?.role?.name
	|| store.getters.user.user?.name
	|| brand_name.value
	|| 'Admin'
));
const currentUserInitials = computed(() => currentUserName.value
	.split(/\s+/)
	.filter(Boolean)
	.slice(0, 2)
	.map(part => part.charAt(0).toUpperCase())
	.join(''));

const topBarColor = computed(() => ({
	'background-color': store.state.brand_skins['topbar_bg_color'],
}));

const getChatIdentity = () => {
	const role = (store.getters.role || '').split('-')[0];
	const id = store.getters.user.user?.role?.id;
	const type = role === 'staff' ? 'staffs' : role === 'customer' ? 'customers' : role;
	return { type, id };
};

const availabilityStorageKey = () => {
	const identity = getChatIdentity();
	return `chat-availability:${store.getters.brand?.id}:${identity.type}-${identity.id}`;
};

const startPresenceListener = () => {
	stopPresenceListener();
	stopPresenceListener = setupUserPresence(
		getChatIdentity(),
		store.getters.brand?.id,
		availability.value
	);
};

const changeAvailability = async () => {
	localStorage.setItem(availabilityStorageKey(), availability.value);
	await setUserAvailability(getChatIdentity(), store.getters.brand?.id, availability.value);
	startPresenceListener();
};

const toggleAvailability = async () => {
	availability.value = isAvailable.value ? 'offline' : 'active';
	await changeAvailability();
};

// Set up real-time listener for unread messages
onMounted(() => {
  const type = store.getters.role;
  const id = store.getters.user.user.role?.id;
  const mappedType = type === 'staff' ? 'staffs' : type === 'customer' ? 'customers' : type;
  const userKey = `${mappedType}-${id}`;
  const brandId = store.getters.brand?.id;
	const savedAvailability = localStorage.getItem(availabilityStorageKey());
	availability.value = savedAvailability === 'available'
		? 'active'
		: savedAvailability === 'away'
			? 'offline'
			: savedAvailability || 'active';
	startPresenceListener();

  // Listen for unread messages count changes
  getUnreadMessagesCount(brandId, userKey, (count) => {
    totalUnreadCount.value = count;
  });
});

const toggleDrawer = () => {
	isDrawerActive.value = !isDrawerActive.value;
};

const logout = (e) => {
	e.preventDefault();
	window.localStorage.removeItem('access_token');
	router.push('/logout');
};
const searchFilter = () => {
	router.push({ name: 'search', params: { query: searchQuery.value } });
	searchQuery.value = '';
};

const hideDrawer = () => {
	isDrawerActive.value = false;
};

onUnmounted(() => {
	stopPresenceListener();
	setUserAvailability(getChatIdentity(), store.getters.brand?.id, 'offline');
});

</script>
<style scoped>
.topbar-item{
	display: flex;
	align-items: center;
}
.drawer-availability-section {
	position: relative;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 14px 16px;
	background: #f8fafc;
	border-bottom: 1px solid #e4e6ef;
}
.availability-profile {
	display: flex;
	align-items: center;
	gap: 10px;
	min-width: 0;
}
.availability-avatar {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	flex: 0 0 38px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border-radius: 50%;
	color: #fff;
	font-size: 12px;
	font-weight: 600;
}
.profile-status-dot {
	position: absolute;
	right: -1px;
	bottom: 0;
	width: 11px;
	height: 11px;
	border: 2px solid #f8fafc;
	border-radius: 50%;
}
.profile-status-dot.active { background: #28a745; }
.profile-status-dot.offline { background: #7e8299; }
.availability-identity {
	display: flex;
	min-width: 0;
	flex-direction: column;
	line-height: 1.25;
}
.availability-identity strong {
	color: #3f4254;
	font-size: 13px;
	font-weight: 600;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.availability-identity > span {
	display: flex;
	align-items: center;
	gap: 5px;
	margin-top: 3px;
	color: #7e8299;
	font-size: 11px;
}
.availability-identity > span i {
	display: inline-block;
	width: 7px;
	height: 7px;
	border-radius: 50%;
}
.availability-identity > span i.active { background: #28a745; }
.availability-identity > span i.offline { background: #7e8299; }
.availability-action {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 7px;
	min-height: 36px;
	padding: 7px 12px;
	background: #fff;
	border: 1px solid #d9dce5;
	border-radius: 8px;
	color: #5e6278;
	font-size: 11px;
	font-weight: 600;
	white-space: nowrap;
	cursor: pointer;
	transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}
.availability-action:hover {
	background: #f3f6f9;
	border-color: #b5b5c3;
	color: #3f4254;
}
.availability-action.set-active {
	background: #f6fcf8;
	border-color: #bfe5ca;
	color: #28a745;
}
.user-card {
	width:700px;
	height:500px;
	overflow-y: auto;
}
.chat-box {
	padding-left: 5px;
	padding-right: 5px;
	cursor: pointer;
}

.chat-box:hover {
	background-color: #f1f1f1;
}
.btn.btn-clean i {
	color: #B5B5C3 !important;
}

@media (min-width: 992px) {

	.header-menu .menu-nav>.menu-item {
		background-color: #fff !important;
		border-radius: 3px;
	}
}

@media (max-width: 991.98px) {
	#kt_header {
		display: flex !important;
		height: 55px;
		min-height: 55px;
		position: relative !important;
		left: auto !important;
		z-index: 97;
	}
	#kt_header > .container-fluid {
		width: 100%;
		padding-right: 15px;
		padding-left: 15px;
		align-items: center !important;
		flex-wrap: nowrap;
	}
	#kt_header .header-menu-wrapper {
		display: flex !important;
		flex: 1 1 auto;
		min-width: 0;
		position: static !important;
		width: auto !important;
		height: auto !important;
		overflow: visible !important;
		background: transparent !important;
		box-shadow: none !important;
	}
	#kt_header .header-menu,
	#kt_header .header-menu .menu-nav {
		display: flex !important;
		align-items: center;
		width: auto !important;
		height: 100%;
		margin: 0;
		padding: 0;
		background: transparent !important;
	}
	#kt_header .header-menu .menu-item {
		overflow: hidden;
		text-overflow: ellipsis;
		padding: 0;
		white-space: nowrap;
	}
	#kt_header .topbar {
		display: flex !important;
		flex: 0 0 auto;
		position: static !important;
		top: auto !important;
		right: auto !important;
		left: auto !important;
		height: 55px;
		margin: 0 0 0 auto !important;
		padding: 0;
		background: transparent !important;
		box-shadow: none !important;
		transform: none !important;
		opacity: 1 !important;
		visibility: visible !important;
		z-index: 1;
	}
	#kt_header .topbar > *,
	#kt_header .topbar .topbar-item,
	#kt_header .topbar .dropdown {
		display: flex !important;
		flex: 0 0 auto;
		align-items: center;
	}
}

@media (max-width: 575.98px) {
	.drawer-availability-section {
		align-items: stretch;
		flex-direction: column;
		gap: 10px;
		padding: 12px;
	}
	.availability-action { width: 100%; }
}
</style>
